<template>
  <div id="hres4ax-popup2-tab1" class="panel box-collapse border-color-skin">
    <div class="box-header with-border box-header-collapse collapsed  tab-header" data-toggle="collapse" data-parent="#accordion2" href="#popup2tab1">
      <h3 class="box-title">
        <i class="fa fa-file-text-o margin-r-5 margin-r-5"></i>{{ labels['STDPOSP1']['20'] }}
      </h3>
    </div>
    <div id="popup2tab1" class="panel-collapse collapse tab-detail">
      <div class="panel-body">
        <div class="detail detail-responsive panel-detail-filter">

          <form class="form-horizontal">
            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['STDPOSP1']['60'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{ data.nameminpos }}</div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['STDPOSP1']['70'] }}</label>
              <div class="col-md-2">
                <div class="form-control readonly-field-color align-center">{{ data.joblvlst }}</div>
              </div>
              <div class="col-md-1 align-center">
                _
              </div>
              <div class="col-md-2">
                <div class="form-control readonly-field-color align-center">{{ data.joblvlen }}</div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['STDPOSP1']['80'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{ data.codjob }} - {{ data.desc_codjob }}</div>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['STDPOSP1']['90'] }}</label>
              <div class="col-md-6">
                <textarea class="form-control readonly-field-color" maxlength="600">{{ data.remarks }}</textarea>
              </div>
            </div>

            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['STDPOSP1']['100'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{ data.jobgrade }} - {{ data.desc_jobgrade }}</div>
              </div>
            </div>
            
            <div class="form-group margin-b-5">
              <label class="col-md-3 control-label">{{ labels['STDPOSP1']['110'] }}</label>
              <div class="col-md-6">
                <div class="form-control readonly-field-color">{{ data.jobgroup }} - {{ data.desc_jobgroup }}</div>
              </div>
            </div>
          </form>

        </div>
      </div>
      <div class="modal-footer" >
      </div>
    </div>
  </div>

</template>

<script>
export default {
  name: 'hres4ax-popup2-tab1',
  props: [ 'labels', 'data' ]
}
</script>


// WEBPACK FOOTER //
// popup2Tab1.vue?61fa0754